import { render, staticRenderFns } from "./select-option-customer.vue?vue&type=template&id=68df10f2&"
import script from "./select-option-customer.vue?vue&type=script&lang=js&"
export * from "./select-option-customer.vue?vue&type=script&lang=js&"
import style0 from "./select-option-customer.vue?vue&type=style&index=0&id=68df10f2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports